"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function composeReducer() {
  var reducers = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    reducers[_i] = arguments[_i];
  }

  return function (state, action) {
    return reducers.reduce(function (_state, reducer) {
      return reducer(_state, action);
    }, state);
  };
}

exports.composeReducer = composeReducer;

exports.initialStateReducer = function (initialState) {
  return function (_state) {
    if (_state === void 0) {
      _state = initialState;
    }

    return _state;
  };
};
/**
 * Make a reducer out of a map: {[actionType string]: Reducer }
 * @param map
 */


exports.fromMap = function (map) {
  return function (state, action) {
    return map[action.type] ? map[action.type](state, action) : state;
  };
};

exports.scopeReducers = function (reducerMap) {
  return composeReducer.apply(void 0, Object.entries(reducerMap).map(function (_a) {
    var key = _a[0],
        value = _a[1];
    return function (_state, _action) {
      var next = value(_state[key], _action);
      return next === _state[key] ? _state : Object.assign({}, _state, (_a = {}, _a[key] = next, _a));

      var _a;
    };
  }));
};